import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {vn_app_zone_notification} from "../../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;

export default class sensaiFeatureFeedback_template extends vnTemplate {

    /** @inheritDoc */
    protected getTemplateHtml(): string{

        return `
            <div class="w-lightbox light-theme zone-activation" data-bind="css: { 'is-visible': isVisible }">
                <div class="lightbox-content">
                    <div class="w-form w-form-large">
                        <div class="form-header">
                            <h3 class="form-title" data-bind="text: title"></h3>
                            <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickClose }"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                <span class="form-label">Category</span>
                                <br/>
                                <select data-bind="value: category, event: { blur: onUpdate }">
                                    <option value="" disabled>Select an Option</option>
                                    <option value="Feature Quality">Feature Quality</option>
                                    <option value="Performance & Technical Issues">Performance & Technical Issues</option>
                                    <option value="Suggestions">Suggestions</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <span class="form-label">Message</span>
                                <textarea style="height:200px" data-bind="value: message, event: { blur: onUpdate }"></textarea>
                            </div>
                         </div>

                        <div class="form-footer">
                            <button class="btn " type="button" data-bind="event: { click: onClickClose }"><span>Cancel</span></button>
                            <button class="btn highlight" type="button" data-bind="event: { click: onClickConfirm }, attr: { disabled: isNotValid }"><span>Submit</span></button>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    /** @inheritDoc */
    protected initPartial(): void{

    }

    /** @inheritDoc */
    protected getTemplateName(): string{

        return 'sensaiFeatureFeedback_template';
    }

    /** @inheritDoc */
    protected getMainElementClasses(): Array<string>{

        return [];
    }

    /** @inheritDoc */
    public buildViewModel(): Object{

        let self = this;

        return {
            title: ko.observable('Submit Feedback'),
            category: ko.observable(''),
            message: ko.observable(''),
            isVisible: ko.observable(false),
            isNotValid: ko.observable(true),
            onClickClose: function(){ self.onClickClose(); },
            onClickConfirm: function(){ self.onClickConfirm(); },
            onUpdate: function() {
                this.isNotValid(!(!!this.message().trim() && !!this.category().trim()));
            }
        };
    }


    // Set the modal's title.
    public setTitle(title: string){

        this.getTemplateViewModel().title(title);
    }

    // Returns true if modal is visible.
    public isVisible(){

        this.getTemplateViewModel().isVisible();
    }

    //
    // Show modal.
    public show(){

        this.getTemplateViewModel().isVisible(true);
    }

    //
    // Hide modal.
    public hide(){

        this.getTemplateViewModel().isVisible(false);
    }

    //
    // Handles on close button click event.
    public onClickClose(){

        this.hide();
        this.caller.onSensaiFeatureFeedbackClose();
    }

    private getVnAppZone() {
        try {
            if (this.caller.getVnAppZone) {
                return this.caller.getVnAppZone();
            } else if (this.caller.caller) {
                if (this.caller.caller.getVnAppZone) {
                    return this.caller.caller.getVnAppZone();
                }
            }
        } catch(e) {

        }

        return null;
    }

    //
    // Handles on confirm button click event.
    public onClickConfirm(){
        let data = this .getTemplateViewModel();
        let feedback = {};
        if (data.message()) {
            feedback['message'] = data.message();
        }
        if (data.category()) {
            feedback['category'] = data.category();
        }
        let allFieldsPresent = true;
        let requiredFields = ['message', 'category'];

        requiredFields.map((k) => {
            if (!feedback[k])
                allFieldsPresent = false;
        });

        let vnZone = this.getVnAppZone();

        if (allFieldsPresent) {
            this.caller.onSensaiFeatureFeedbackConfirm(feedback);
            data.message('');
            data.category('');
            data.isNotValid(true);
            this.hide();
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/sensaiFeatureFeedback_template.ts